import { Activity, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import { fmtTime } from "./auditTrail";

const TONE = {
  success: { icon: CheckCircle2, cls: "text-emerald-300 bg-emerald-500/15 border-emerald-500/25" },
  pending: { icon: Loader2, cls: "text-sky-300 bg-sky-500/15 border-sky-500/25" },
  flag: { icon: AlertCircle, cls: "text-amber-300 bg-amber-500/15 border-amber-500/25" },
  info: { icon: Activity, cls: "text-white/70 bg-white/5 border-white/15" },
};

/**
 * Sticky right-rail audit-trail panel.
 * Shows the running list of compliance events that the sandboxed signup
 * fires as the bank reviewer clicks Next on each step.
 */
export default function AuditPanel({ trail }) {
  return (
    <aside
      className="sticky top-24 self-start rounded-xl border border-white/10 bg-white/[0.03] p-5"
      data-testid="bank-demo-audit-panel"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Activity className="w-4 h-4 text-white/70" />
          <h3 className="text-[13px] font-semibold tracking-wide uppercase text-white/80">Audit trail</h3>
        </div>
        <span className="text-[11px] text-white/50" data-testid="bank-demo-audit-count">
          {trail.length} {trail.length === 1 ? "event" : "events"}
        </span>
      </div>
      {trail.length === 0 ? (
        <p className="text-[13px] text-white/50 leading-relaxed">
          Compliance events appear here as you move through the signup. Every action is timestamped, actor-scoped, and
          stored append-only (WORM) for the sponsor bank's regulatory record.
        </p>
      ) : (
        <ol className="space-y-3">
          {trail.map((ev) => {
            const tone = TONE[ev.status] || TONE.info;
            const Icon = tone.icon;
            return (
              <li
                key={ev.id}
                className={`flex items-start gap-3 rounded-lg border ${tone.cls} px-3 py-2.5`}
                data-testid={`bank-demo-audit-event-${ev.action}`}
              >
                <Icon
                  className={`w-4 h-4 mt-0.5 flex-shrink-0 ${ev.status === "pending" ? "animate-spin" : ""}`}
                />
                <div className="min-w-0 flex-1">
                  <div className="text-[12.5px] font-medium leading-snug">{ev.action}</div>
                  <div className="text-[11.5px] text-white/60 mt-0.5 leading-snug">
                    <span className="font-mono">{fmtTime(ev.at)}</span>
                    {ev.actor && <span className="ml-1.5">· {ev.actor}</span>}
                  </div>
                  {ev.meta && (
                    <div className="text-[11.5px] text-white/55 mt-1 leading-snug whitespace-pre-line">{ev.meta}</div>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </aside>
  );
}
